/**
 * Build viewer tabs for Tutorial orchestration output — one tab per pass + derived views.
 */
export function buildOrchestrationViewerTabs(orchestration) {
  if (!orchestration) return [];

  const history = orchestration.pass_history || {};
  const pass = orchestration.pipeline_pass || 1;
  const tabs = [];

  if (orchestration.pass_log?.length) {
    tabs.push({
      id: 'pass_log',
      label: 'Pass log',
      data: orchestration,
      pass,
    });
  }

  if (history.pass1) {
    tabs.push({
      id: 'pass1',
      label: 'Pass 1 — Concept tree',
      data: history.pass1,
      pass: 1,
    });
  }
  if (history.pass2) {
    tabs.push({
      id: 'pass2',
      label: 'Pass 2 — Artifact expansion',
      data: history.pass2,
      pass: 2,
    });
  }
  if (history.pass2_optimize) {
    tabs.push({
      id: 'pass2_optimize',
      label: 'Pass 2 optimize',
      data: history.pass2_optimize,
      pass: 2,
    });
  }
  if (history.pass3) {
    tabs.push({
      id: 'pass3',
      label: 'Pass 3 — Trainer script',
      data: history.pass3,
      pass: 3,
    });
  }

  tabs.push({
    id: 'orchestration',
    label: `Full document (pass ${pass})`,
    data: orchestration,
    pass,
  });

  if (pass >= 2 && orchestration.derived?.topic_tree?.length) {
    tabs.push({
      id: 'derived_tree',
      label: 'Derived DFS tree',
      data: orchestration,
      pass,
    });
  }
  if (pass >= 2 && orchestration.derived?.dfs_stack_preview?.length) {
    tabs.push({
      id: 'dfs',
      label: 'DFS stack order',
      data: orchestration,
      pass,
    });
  }
  if (pass >= 3 && orchestration.script) {
    tabs.push({
      id: 'script',
      label: 'Render script JSON',
      data: { script: orchestration.script, topic: orchestration.topic },
      pass: 3,
    });
  }

  return tabs;
}

export function orchestrationPassStatuses(orchestration) {
  if (!orchestration) return [];
  const status = orchestration.pass_status || {};
  return [
    { id: 'pass1', label: 'Pass 1', state: status.pass1 },
    { id: 'pass2', label: 'Pass 2', state: status.pass2 },
    { id: 'pass3', label: 'Pass 3', state: status.pass3 || status.build_script },
  ];
}
